/*
 * Ürün detayı: teslimat tarihi / kargo geri sayımı / son X adet (snippets/bup-delivery-stock.liquid)
 * ve "Stoğa gelince haber ver" formu (snippets/bup-back-in-stock.liquid).
 */
(function () {
  if (window.bupPdpProofLoaded) return;
  window.bupPdpProofLoaded = true;

  var TZ = 'Europe/Istanbul';
  var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  // Şu anki İstanbul saati; tarih aritmetiği UTC gün değerleri üzerinden yapılır.
  function istanbulNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = parseInt(p.value, 10); });
    return parts;
  }

  function isOffDay(date, skip) {
    var d = date.getUTCDay();
    if (skip === 'weekend') return d === 0 || d === 6;
    if (skip === 'sunday') return d === 0;
    return false;
  }

  function addWorkDays(date, days, skip) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (!isOffDay(d, skip)) days--;
    }
    return d;
  }

  // odsport giesto-delivery-timeline ile aynı biçim: "12 Ekim" / "12 Ekim - 13 Ekim"
  function formatDay(d) { return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; }
  function formatRange(a, b) {
    return a.getTime() === b.getTime() ? formatDay(a) : formatDay(a) + ' - ' + formatDay(b);
  }

  function updateDelivery(root) {
    var min = parseInt(root.dataset.minDays, 10) || 0;
    var max = Math.max(parseInt(root.dataset.maxDays, 10) || 0, min);
    var cutoff = parseInt(root.dataset.cutoff, 10);
    var skip = root.dataset.skip;
    var now = istanbulNow();
    var today = new Date(Date.UTC(now.year, now.month - 1, now.day));

    // Kesim saatinden önce ve iş günüyse bugün kargoda, değilse bir sonraki iş günü.
    var shipsToday = !isOffDay(today, skip) && now.hour < cutoff;
    var shipDay = shipsToday ? today : addWorkDays(today, 1, skip);
    var text = formatRange(addWorkDays(shipDay, min, skip), addWorkDays(shipDay, max, skip));

    var box = root.bupBox || root;
    box.querySelectorAll('[data-bup-date]').forEach(function (el) { el.textContent = text; });
    box.querySelectorAll('[data-bup-purchased]').forEach(function (el) { el.textContent = formatDay(today); });
    box.querySelectorAll('[data-bup-shipped]').forEach(function (el) { el.textContent = formatDay(shipDay); });

    // Geri sayım odsport'taki gibi: bir sonraki kargo gününün kesim saatine kalan süre, 24 saatlik döngüde (SS:DD:sn).
    var cutoffRow = box.querySelector('[data-bup-cutoff]');
    var plainRow = box.querySelector('[data-bup-plain]');
    if (cutoffRow) {
      cutoffRow.hidden = false;
      if (plainRow) plainRow.hidden = true;
      var dayGap = Math.round((shipDay.getTime() - today.getTime()) / 86400000);
      var left = Math.max(0, dayGap * 86400 + cutoff * 3600 - (now.hour * 3600 + now.minute * 60 + now.second)) % 86400;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var label = pad(Math.min(23, Math.floor(left / 3600))) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      cutoffRow.querySelectorAll('[data-bup-time]').forEach(function (el) { el.textContent = label; });
    }
  }

  function initProof(root) {
    if (root.dataset.bupReady) return;
    root.dataset.bupReady = 'true';

    // Kargo kutusunu buton alanının en altına (Sepete Ekle / Hemen Satın Al / Favorilere Ekle'nin altına) taşı.
    var box = root.querySelector('[data-bup-delivery]');
    if (box) root.bupBox = box;
    if (box && root.dataset.position === 'after_buttons') {
      var submit = document.getElementById('ProductSubmitButton-' + root.dataset.bupSection);
      var buttons = submit && submit.closest('.product-form__buttons');
      if (buttons) buttons.appendChild(box);
    }
    updateDelivery(root);
    setInterval(function () { updateDelivery(root); }, 1000);
  }

  function initBis(root) {
    if (root.dataset.bupReady) return;
    root.dataset.bupReady = 'true';
    var form = root.querySelector('form');
    var toggle = root.querySelector('[data-bup-bis-toggle]');
    var panel = root.querySelector('.bup-bis__panel');
    if (!form || !toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (open) panel.querySelector('input[type="email"]').focus({ preventScroll: true });
    });

    form.addEventListener('submit', function (e) {
      if (form.dataset.native) return;
      e.preventDefault();
      var submit = form.querySelector('[type="submit"]');
      var error = form.querySelector('.bup-bis__error');
      submit.disabled = true;
      error.hidden = true;

      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (res) {
          // Shopify bot doğrulaması isterse formu normal gönder (doğrulama sayfası açılır, sonra geri döner).
          if (res.url.indexOf('/challenge') !== -1) {
            form.dataset.native = 'true';
            form.submit();
            return;
          }
          if (!res.ok || res.url.indexOf('contact_posted=true') === -1) throw new Error('contact form');
          panel.hidden = true;
          toggle.hidden = true;
          form.querySelector('.bup-bis__success').hidden = false;
        })
        .catch(function () {
          error.hidden = false;
        })
        .finally(function () {
          submit.disabled = false;
        });
    });
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.variant) return;
    var variant = data.variant;
    var sectionId = data.sectionId;

    document.querySelectorAll('[data-bup-bis][data-bup-section="' + sectionId + '"]').forEach(function (root) {
      root.hidden = !!variant.available;
      var set = function (sel, val) { var el = root.querySelector(sel); if (el) el.value = val; };
      set('[data-bup-bis-variant]', variant.title || '');
      set('[data-bup-bis-sku]', variant.sku || '');
      var link = root.querySelector('[data-bup-bis-link]');
      if (link) link.value = link.dataset.base + '?variant=' + variant.id;
    });

    document.querySelectorAll('[data-bup-proof][data-bup-section="' + sectionId + '"]').forEach(function (root) {
      root.dataset.available = String(!!variant.available);
      var delivery = root.bupBox || root.querySelector('[data-bup-delivery]');
      if (delivery) delivery.hidden = !variant.available;

      var stock = root.querySelector('.bup-proof__stock');
      var source = data.html && data.html.querySelector('.bup-proof__stock');
      if (stock && source) {
        stock.innerHTML = source.innerHTML;
        stock.hidden = source.hidden;
      }
      updateDelivery(root);
    });
  }

  function init() {
    document.querySelectorAll('[data-bup-proof]').forEach(initProof);
    document.querySelectorAll('[data-bup-bis]').forEach(initBis);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
